import state from './fileset.state'
import mutations from './fileset.mutations'
import actions from './fileset.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
